import {isObject, map, omit} from "underscore";

const formatTool = (tool) => tool?.replace(/^mcp_/, "").replace(/_/g, ".") || "";

export const cleanOperationResultForDisplay = (result) =>
  isObject(result) ? omit(result, "updatedPageContext") : result;

const formatAgentErrors = (errors) =>
  JSON.stringify(
    map(errors, (error) => ({
      tool: formatTool(error?.tool),
      error: error?.error || error?.result?.error || "Unknown error",
    })),
    null,
    2,
  );

const formatAgentOperations = (operations) =>
  JSON.stringify(
    map(operations, (operation) => ({
      tool: formatTool(operation?.tool),
      status: operation?.status,
      result: cleanOperationResultForDisplay(operation?.result),
    })),
    null,
    2,
  );

const formatConfirmationResults = (items) =>
  map(items, (item, i) => {
    if (!item) {
      return "";
    }
    const icon = item.status === "approved" ? "✅" : "🚫";
    const input = JSON.stringify(item.input, null, 2);
    return `${i + 1}. ${icon} ${item.description || ""}\n${input}`;
  }).join("\n");

export const chatbotMessageToPlainText = (message) => {
  if (!message) {
    return "";
  }
  const parts = [message.text || ""];
  const resultItems = message.confirmationResult?.items || [];
  if (resultItems.length > 0) {
    parts.push(formatConfirmationResults(resultItems));
  }
  if (message.agentResult?.operations?.length > 0) {
    parts.push(formatAgentOperations(message.agentResult.operations));
  }
  if (message.agentErrors?.length > 0) {
    parts.push(formatAgentErrors(message.agentErrors));
  }
  return parts.join("\n\n");
};

export const chatbotSessionToPlainText = (messages) =>
  map(messages, (message) => {
    const sender = message?.sender === "user" ? "You" : "Rex AI\u00ae";
    return `${sender}: ${chatbotMessageToPlainText(message)}`;
  }).join("\n\n");
